<template>
  <v-app id="app">
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" fixed app style="display: flex; flex-direction: column; justify-content: space-between; max-height: 100%">
      <v-list dense>
        <v-list-tile @click="goToTournamentList()">
          <v-list-tile-action>
            <v-icon>list</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Tournaments' List</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <div style="padding: 20px">
        <small>Version: 20220414</small>
      </div>
    </v-navigation-drawer>

    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="indigo darken-4" dark fixed app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title style="display: flex; align-items: center">
        <svg width="30px" height="30px" fill="#fff" viewBox="0 0 2081 2005" version="1.1">
          <g transform="matrix(4.16667,0,0,4.16667,1005.05,1330.63)">
            <g>
              <path d="M0,-157.585C-14.668,-188.831 -25.813,-221.689 -33.242,-255.647C-55.463,-254.121 -77.368,-251.427 -98.871,-247.544C-87.529,-192.46 -67.651,-139.836 -39.893,-91.294C-24.641,-112.298 -11.315,-134.469 0,-157.585M-49.872,-78.08C-80.157,-129.627 -101.712,-185.782 -113.803,-244.656C-135.488,-240.171 -156.73,-234.477 -177.508,-227.722C-162.168,-155.395 -134.275,-87.788 -96.2,-27.37C-81.926,-40.065 -58.972,-66.112 -49.872,-78.08M115.792,-247.544C94.291,-251.427 72.386,-254.121 50.163,-255.647C27.968,-154.836 -23.649,-74.259 -87.753,-14.323C-75.407,4.211 -62.063,22.001 -47.845,39.025C29.511,-30.772 91.803,-130.117 115.792,-247.544M130.725,-244.653C108.286,-135.335 51.975,-30.804 -37.895,50.641C-23.289,67.276 -7.83,83.12 8.46,98.062C115.927,-0.647 171.844,-120.889 194.428,-227.722C173.653,-234.477 152.409,-240.171 130.725,-244.653"/>
            </g>
          </g>
        </svg>
        <span style="margin-left: 20px">Beach Live Center</span>
      </v-toolbar-title>
    </v-toolbar>

    <v-content>
      <v-container fluid fill-height>
        <v-layout>
          <v-flex>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'app',

  data: () => ({
    drawer: false,
  }),

  methods: {
    goToTournamentList () {
      this.$router.push({ name: 'TournamentList' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue